import React from 'react';
import Loader from '../../../../../utils/Loader';

export default function ReportLoader({ visible = false, message = 'Report is generating...', subMessage = '' }) {
  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.45)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: 20
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 8,
        padding: '18px 22px',
        maxWidth: 520,
        width: '100%',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        display: 'flex',
        gap: 16,
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
        <div style={{ minWidth: 64, minHeight: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Loader />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#10243a', marginBottom: 6 }}>{message}</div>
          {subMessage ? <div style={{ fontSize: 13, color: '#4b5563' }}>{subMessage}</div> : <div style={{ fontSize: 13, color: '#4b5563' }}>This may take a minute. Please wait...</div>}
        </div>
      </div>
    </div>
  );
}
